import {
  CaretDownOutlined,
  CheckCircleOutlined,
  HistoryOutlined,
  StopOutlined,
} from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  approveSurvey,
  archiveSurvey,
  downloadCSVReport,
  downloadPDFReport,
} from "../../../../slices/Employee/survey-CRR.slice";
import { showSuccess } from "../../../../helpers/Notifications/Notification";
import text from "../../../../helpers/text";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { SURVEYS } from "../../../../helpers/constants";
import { toggleSurveyEditable } from "../../../../slices/Admin/surveyList.slice";
import { Button } from "../../../../components/ds";

const SurveyActions = ({ setDrawerVisible, requestData, selectedSurvey }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isPdfDownloading, isCsvDownloading } = useSelector(
    (state) => state.CRRsurvey
  );
  const { surveyEditable } = useSelector((state) => state.surveyList);
  const { activeSurvey } = useSelector((state) => state.signIn);
  const {
    id = "",
    status: crr_survey_status = "",
    name = "",
  } = selectedSurvey;

  const [actionsOpen, setActionsOpen] = useState(false);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const actionsRef = useRef(null);
  const downloadRef = useRef(null);

  useEffect(() => {
    if (!actionsOpen && !downloadOpen) return undefined;
    const onDoc = (e) => {
      if (
        actionsOpen &&
        actionsRef.current &&
        !actionsRef.current.contains(e.target)
      ) {
        setActionsOpen(false);
      }
      if (
        downloadOpen &&
        downloadRef.current &&
        !downloadRef.current.contains(e.target)
      ) {
        setDownloadOpen(false);
      }
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [actionsOpen, downloadOpen]);

  const handleCsvDownload = () => {
    setDownloadOpen(false);
    dispatch(
      downloadCSVReport(id, name, () => {
        showSuccess("CSV downloaded successfully");
      })
    );
  };

  const handleSurveyArchive = () => {
    setActionsOpen(false);
    dispatch(
      archiveSurvey(requestData, () => {
        showSuccess("Survey archived successfully");
        history.push("/admin-survey-list");
      })
    );
  };

  const handlePdfDownload = () => {
    setDownloadOpen(false);
    dispatch(
      downloadPDFReport(id, () => {
        showSuccess("PDF downloaded successfully");
      })
    );
  };

  const handleApprove = () => {
    setActionsOpen(false);
    dispatch(
      approveSurvey(requestData, () => {
        showSuccess("Assessment Approved");
        history.push("/admin-survey-list");
      })
    );
  };

  const downloading = isPdfDownloading || isCsvDownloading;

  return (
    <div>
      <div className="survey-btns">
        {(crr_survey_status === "In Progress" ||
          activeSurvey === SURVEYS.CSF) && (
          <button
            type="button"
            role="switch"
            aria-checked={Boolean(surveyEditable)}
            className={`update-toggle-btn${surveyEditable ? " is-checked" : ""}`}
            onClick={() => dispatch(toggleSurveyEditable())}
          >
            <span className="update-toggle-label">
              {surveyEditable ? "UPDATE" : "VIEW"}
            </span>
          </button>
        )}

        {crr_survey_status === "In Progress" && (
          <div className="survey-menu-wrap survey-actions" ref={actionsRef}>
            <button
              type="button"
              className="btn create-survey-btn download-btn"
              disabled={isCsvDownloading}
              onClick={() => {
                setDownloadOpen(false);
                setActionsOpen((o) => !o);
              }}
            >
              {isCsvDownloading ? (
                text.downloading
              ) : (
                <>
                  ACTIONS <CaretDownOutlined />
                </>
              )}
            </button>
            {actionsOpen ? (
              <div className="survey-dropdown-menu download-menu" role="menu">
                <button
                  type="button"
                  role="menuitem"
                  className="survey-dropdown-item is-danger"
                  onClick={() => {
                    setActionsOpen(false);
                    setDrawerVisible(true);
                  }}
                >
                  <StopOutlined className="icons" />
                  REJECT
                </button>
                <button
                  type="button"
                  role="menuitem"
                  className="survey-dropdown-item"
                  onClick={handleApprove}
                >
                  <CheckCircleOutlined className="icons" />
                  APPROVE
                </button>
                <button
                  type="button"
                  role="menuitem"
                  className="survey-dropdown-item"
                  onClick={handleSurveyArchive}
                >
                  <HistoryOutlined className="icons" />
                  ARCHIVE
                </button>
              </div>
            ) : null}
          </div>
        )}

        <div className="survey-menu-wrap" ref={downloadRef}>
          <Button
            className="btn survey-response-btn"
            disabled={downloading}
            title="DOWNLOAD REPORT"
            onClick={() => {
              setActionsOpen(false);
              setDownloadOpen((o) => !o);
            }}
          >
            {downloading ? (
              text.downloading
            ) : (
              <>
                DOWNLOAD <span>REPORT</span>
              </>
            )}
          </Button>
          {downloadOpen ? (
            <div className="survey-dropdown-menu download-menu" role="menu">
              <button
                type="button"
                role="menuitem"
                className="survey-dropdown-item"
                onClick={handlePdfDownload}
                disabled={isPdfDownloading}
              >
                {text.download_pdf}
              </button>
              <button
                type="button"
                role="menuitem"
                className="survey-dropdown-item"
                onClick={handleCsvDownload}
              >
                {text.download_csv}
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SurveyActions;
